import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sumTotal'
})
export class SumTotalPipe implements PipeTransform {

  /**
   * Accese a la propiedad y retorna el valor total de la suma
   * @param array el paquete acumulado de los objetos
   * @param propiedad a acceder para reducir los valores
   * @returns el valor total de la suma
   */
  transform = (array: Array<any>, property: string): number =>
    array.map(p => p[property]).reduce((a, b) => a + b, 0);

}
